module.exports = "body {\n  background: black; }\n"